<template>
  <div class="container">
    <Fontnavbar title="拼团订单详情" />

    <!-- 遮罩层 开始 -->
    <van-overlay :show="overlay_show" @click="overlay_show = false">

      <van-image
          class="up-arrow"
          fit="contain"
          width="100"
          :src="require('@/../public/static/up-arrow.gif')"
      />

      <div class="overlay_box" @click.stop="overlay_show = false">
        <div class="title">还差<span class="red">1</span>人，赶快邀请好友来拼单吧</div>
        <div class="desc">拼单已发起，人满后立即发货</div>
<!--        <van-icon class="close" name="close" />-->
      </div>
    </van-overlay>
    <!-- 遮罩层 结束 -->

    <div class="goods-item" v-if="goods_info" @click="goPage('/goods/groupBuy/goodsDetail?id=' + goods_info.goods_id +'&group_id=' + goods_info.group_id)">
      <van-image
          class="goods-cover"
          fit="contain"
          :src="imgDomain + goods_info.goods_thumb_path"
      />
      <div class="goods-info">
        <div class="goods-name">{{ goods_info.goods_name }}</div>
        <div class="goods-price-info">
          <div class="goods-price">￥{{ goods_info.goods_price }}</div>
          <div class="user-price">￥{{ goods_info.user_price }}</div>
          <div class="count">已拼{{ goods_info.already }}件</div>
        </div>
      </div>
    </div>

    <div class="group-info" v-if="group">
      <div class="user-avatar-list">
        <div class="avatar-box" v-for="(member, index) in group.member" :key="'avatar-' + index">
          <van-image
              v-if="member.user_id != 0"
              :class="{'user-avatar':true, 'master':member.is_sponsor}"
              round
              width="50"
              height="50"
              fit="contain"
              :src="imgDomain + member.avatar"
          >
            <template v-if="member.user_id != 0" v-slot:error>{{member.username.substr(0,1)}}</template>
          </van-image>
          <van-image
              v-if="member.user_id == 0"
              class="user-avatar empty"
              round
              width="50"
              height="50"
              fit="contain"
              src="https://img01.yzcdn.cn/vant/cat.jpeg"
          />
          <span class="mark" v-if="member.is_sponsor">拼主</span>
        </div>

      </div>
      <div class="group-desc" v-if="!group.is_join && !group.is_over">
        仅剩余<div class="surplus">{{ group.group_people_limit - group.member_count }}</div>个名额，<van-count-down class="count-down" :time="group.countdown * 1000" format="HH:mm:ss" />后结束
      </div>
      <div class="group-desc" v-if="group.is_sponsor && !group.is_over" >
        还剩1人，赶紧邀请好友来拼单吧
      </div>
      <div class="group-desc" v-if="(group.is_join && !group.is_sponsor) || (group.is_sponsor && group.member_count>1)">
        您已拼团成功！
      </div>
      <div class="group-desc" v-if="group.is_sponsor && group.member_count == 1 && group.is_over">
        免拼成功！
      </div>
      <div class="group-desc" v-if="group.is_over && !group.is_join">
        拼团时间已到
      </div>
      <div class="small-btn" v-if="group.is_join || group.is_sponsor && group.member_count>1" @click="goPage('/order/detail?order_no=' + group.my_order)">查看订单</div>
      <div class="join-btn" v-if="!group.is_join && !group.is_over" @click="join">参与 {{ group.master }} 的拼单</div>
      <div class="join-btn" v-if="group.is_join || group.is_sponsor && group.member_count>1" @click="goPage('/goods/groupBuy/goodsDetail?id=' + goods_info.goods_id +'&group_id=' + goods_info.group_id)">再来一单</div>
      <div class="join-btn" v-if="group.is_sponsor && group.member_count == 1" @click="overlay_show = true">邀请好友拼单</div>
      <div class="join-btn" v-if="group.is_sponsor" @click="goPage('/')">去首页逛逛</div>
    </div>

    <div class="goods">
      <div class="title"> --- 精品推荐 --- </div>

      <div class="recommend">
        <div class="recommend-item" v-for="(goods, index) in recommendGoods" :key="'rec-' + index" @click="goPage('/goods/detail?id=' + goods.id)">
          <van-image
              class="recommend-goods-cover"
              fit="contain"
              :src="imgDomain + goods.goods_thumb_path"
          />
          <div class="recommend-goods-name">{{ goods.goods_name }}</div>
          <div class="recommend-goods-info">
            <div class="recommend-goods-price">￥{{ goods.user_price }}</div>
            <van-icon class="recommend-goods-btn" name="shopping-cart" />
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
    var jweixin = require('jweixin-module')
    import Fontnavbar from '../../../components/NavbarShare.vue'
    import { getGroupInfo, getSigned } from '../../../api.js'
    import { post } from '../../../request.js'
    import {
        Image,
        CountDown,
        Icon,
        Overlay,
    } from 'vant'

    export default {
        name: "orderDetail",
        components: {
            [Image.name]: Image,
            [CountDown.name]: CountDown,
            [Icon.name]: Icon,
            [Overlay.name]: Overlay,
            Fontnavbar,
        },

        data() {
            return {
                imgDomain: process.env.VUE_APP_IMG_URL, // oss图片地址
                goods_info:null,
                group:null,
                sn:null,
                recommendGoods:null,
                overlay_show:false,
            }
        },
        created () {
            this.sn = this.$route.query.sn ? this.$route.query.sn : ''
            this.loadData();
        },
        methods: {
            loadData(){
                let that = this
                post(getGroupInfo, {part_sn:that.sn}).then(res => {
                    console.log(res)
                    if (res.code == 200) {
                        that.goods_info = res.data.goods_info
                        that.group = res.data.group
                        that.recommendGoods = res.data.recommend_list
                        if (res.data.goods_info){
                            that.initShare()
                        }
                    } else {
                        this.$router.push({ path: "/user/login" });
                    }

                })
            },
            join(){
                // console.log(goods_id, this.goods_num, sn)
                var url = '/goods/groupBuy/join?goods_id='+ this.goods_info.goods_id +'&goods_num=1&sn=' + this.sn
                this.goPage(url);
            },
            goPage (path) {
                this.$router.push({ path: path })
            },
            initShare(){
                let that = this
                let url  = encodeURIComponent(window.location.href.split('#')[0]);
                post(getSigned, {url:url}).then(res => {
                    jweixin.config({
                        debug: false,
                        appId: res.data.appId,
                        timestamp: res.data.timestamp,
                        nonceStr: res.data.nonceStr,
                        signature: res.data.signature,
                        jsApiList: [
                            'checkJsApi',
                            'updateAppMessageShareData',
                            'updateTimelineShareData',
                            'showOptionMenu',
                        ]
                    });
                    jweixin.ready(function() {
                        var shareData = {
                            title: '【仅剩1个名额】我'+ that.goods_info.goods_price +'元拼了' + that.goods_info.goods_name,
                            desc: that.goods_info.goods_name,
                            link: url,
                            imgUrl: that.imgDomain + that.goods_info.goods_thumb_path,
                        };
                        //自定义“分享给朋友”及“分享到QQ”按钮的分享内容；
                        jweixin.updateAppMessageShareData(shareData)
                        //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容；
                        jweixin.updateTimelineShareData(shareData)

                    });
                })
            }
        }
    }
</script>

<style scoped lang="less">
.container{
  background-color: #fff;
  .goods-item{
    margin-top: 20px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .goods-cover{
      width: 30vw;
    }

    .goods-info{
      .goods-name{
        width: 60vw;
      }
      .goods-price-info{
        margin-top: 15px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .goods-price{
          color: red;
          font-weight: bold;
          font-size: 16px;
        }
        .user-price{
          color: #ccc;
          font-size: 12px;
          text-decoration:line-through
        }
        .count{
          color: #ccc;
          font-size: 14px;
        }
      }
    }

  }

  .group-info{
    margin-top: 20px;
    text-align: center;
    .user-avatar-list{
      display: flex;
      justify-content: center;

      .avatar-box{
        position: relative;
        .user-avatar {
          margin: 0 5px;
        }
        .master{
          border: 1px #ffad3f solid;
        }
        .empty{
          border: 1px #adadad dashed;
        }
        .empty:before{
          content: '?';
          font-size: 22px;
          color: #bdbdbd;
          font-weight: bold;
          line-height: 50px;
        }
        .mark{
          position: absolute;
          left: 0;
          top: -6px;
          background-color: #ffad3f;
          color: #96690f;
          line-height: 18px;
          padding: 0 3px;
          border-radius: 6px;
          text-align: center;
          font-size: 12px;
        }
      }

    }
    .group-desc{
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 20px auto;
      .surplus{
        color: red;
        font-size: 18px;
        font-weight: bold;
      }
      .count-down{
        font-size: 18px;
        font-weight: bold;
      }
    }
    .small-btn{
      display: inline-block;
      padding: 3px 10px;
      background-color: #ea8945;
      color: #ffffff;
      border-radius: 5px;
      margin: 0 auto;
    }
    .join-btn{
      background-color: #e02e24;
      color: #ffffff;
      width: 90vw;
      margin: 10px auto;
      margin-top: 20px;
      height: 40px;
      line-height: 40px;
      border-radius: 5px;
    }
  }

  .goods{
    background-color: #f5f5f5;
    width: 100vw;

    .title{
      text-align: center;
      line-height: 40px;
    }

    .recommend{
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      .recommend-item{
        background-color: #fff;
        width: 45vw;
        margin: 5px 2px;
        padding: 0 5px;

        .recommend-goods-cover{
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .recommend-goods-name{
          font-size: 10px;
        }

        .recommend-goods-info{
          display: flex;
          justify-content: space-between;
          margin: 10px 0;
          .recommend-goods-price{
            color: red;
            font-weight: bold;
          }
          .recommend-goods-btn{
            color: red;
            font-weight: bold;
            margin-right: 5px;
          }
        }
      }

    }
  }

}

  .up-arrow{
    position: fixed;
    right: 5px;
  }
  /*遮罩层样式*/
  .overlay_box{
    background-color: #fff;
    position: relative;
    width: 80vw;
    min-height: 100px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 10px;
    padding: 10px;
    text-align: center;

    .title{
      margin-top: 15px;
      font-weight: bold;
      font-size: 17px;
      line-height: 35px;
    }
    .red{
      color: red;
    }
    .desc{
      color: #515151;
      font-size: 16px;
      line-height: 35px;
    }
    .close{
      position: absolute;
      z-index: 5;
      top: -1px;
      right: -1px;
      font-size: 22px;
      color: #656364;
    }
  }

</style>